export default [
	'VOICEMAIL',
	'PAYMENT_PLAN',
	'PAYMENT_PROMISE',
	'DISPUTE',
	'UNREACHABLE',
	'INCORRECT_NUMBER',
	'OTHER',
	'INBOUND'
];
